import { dataGetAds } from '@weblite/action/ads'
import { adsStorage } from '$logic/ads/storage'
import { getProfile } from '$logic/profile'
import { wsReq } from '$setup/ws'

export const syncAds = async () => {
  const profile = getProfile()
  const { payload } = await wsReq(dataGetAds({ profile: profile?.school }))
  adsStorage.setAdsStorage(payload)
  // if (payload.chatList)
  //   payload.chatList.forEach(({ campaign }) => {
  //     analite('ADS', { c: campaign, a: 's' })
  //   })
}
